export type ActivityModality = 'self-guided' | 'group';

export const normalizeModalityKey = (modality: string | null | undefined): ActivityModality | null => {
  if (!modality) {
    return null;
  }

  const key = modality.toLowerCase().replace(/_/g, '-');
  if (key === 'self-guided' || key === 'selfguided') {
    return 'self-guided';
  }
  if (key === 'group') {
    return 'group';
  }

  return null;
};

export const isSelfGuidedModality = (modality: string | null | undefined): boolean =>
  normalizeModalityKey(modality) === 'self-guided';

export const modalitySelectOptions = [
  { key: 'self-guided', labelKey: 'cms.activities.modalityOptions.selfGuided' },
  { key: 'group', labelKey: 'cms.activities.modalityOptions.group' },
] as const;

export const buildModalitySelectOptions = (t: (key: string) => string) =>
  modalitySelectOptions.map((option) => ({
    key: option.key,
    label: t(option.labelKey),
  }));
